import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import * as Constants from '../models/Constants';
import { RootScopeService } from './root-scope.service';

@Injectable({
  providedIn: 'root'
})
export class EncryptDecryptService {

  constructor(public rootScope: RootScopeService) { }
  /**
   * This service is created
   * for encrytion/decryption
   * @author : Pooja Gupta
   */

  encryptId: any = Constants.SCRET_KY;
  keySize: number = 256;
  ivSize: number = 128;
  iterations: number = 1024;
  private readonly pbkdf2Hasher = CryptoJS.algo.SHA1;

  /*** Below methods are used for encrytion/decryption from angular app to java app *****/
  encrypt(dataToEncrypt) {
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const key = CryptoJS.PBKDF2(this.encryptId, salt, {
      keySize: this.keySize / 32,
      iterations: this.iterations,
      // Keep legacy behavior for backward compatibility with data encrypted pre-4.2.0.
      hasher: this.pbkdf2Hasher
    });

    const iv = CryptoJS.lib.WordArray.random(this.ivSize / 8);

    const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC

    });

    /**  salt, iv will be hex 32 in length append them to the ciphertext for use  in decryption **/
    return salt.toString() + iv.toString() + encrypted.ciphertext.toString();
  }


  decrypt(dataToDecrypt) {
    const salt = CryptoJS.enc.Hex.parse(dataToDecrypt.substr(0, 32));
    const iv = CryptoJS.enc.Hex.parse(dataToDecrypt.substr(32, 32))
    const encryptedHex = dataToDecrypt.substring(64);

    const key = CryptoJS.PBKDF2(this.encryptId, salt, {
      keySize: this.keySize / 32,
      iterations: this.iterations,
      hasher: this.pbkdf2Hasher
    });
    const encryptedText = CryptoJS.enc.Hex.parse(encryptedHex);

    const decrypted = CryptoJS.AES.decrypt({ ciphertext: encryptedText }, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC

    })
    return this.toUtf8WithLatin1Fallback(decrypted);
  }

  /********Below methods  encryption/decryption is for angular to angular app 
   * i.e care portal angular app to Genesys/ALIS angular ***********/
  /**
   * used in genesys for decrypting customer Id where encrypted value flow
   * from genesys angular code
   * @param dataToDecrypt
   * @returns 
   */
  decodeAndDecrypt(dataToDecrypt) {
    let saltKeyALISObj = this.rootScope.getObjFromConfigObj(Constants.GENESYS_CLOUD_ENCRYPTION_KEY);
    const saltKeyALIS = saltKeyALISObj?.fieldValue;

    if (!saltKeyALIS) {
      return '';
    }

    try {
      let _key = CryptoJS.enc.Utf8.parse(saltKeyALIS);
      let _iv = CryptoJS.enc.Utf8.parse(saltKeyALIS);
      const decrypted = CryptoJS.AES.decrypt(dataToDecrypt, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return this.toUtf8WithLatin1Fallback(decrypted);
    } catch (innerError) {
      console.log(innerError);
      return '';
    }
    
  }

  encodeAndEncrypt(dataToEncrypt) {
    let saltKeyALISObj = this.rootScope.getObjFromConfigObj(Constants.GENESYS_CLOUD_ENCRYPTION_KEY);
    const saltKeyALIS = saltKeyALISObj?.fieldValue;

    try {
      let _key = CryptoJS.enc.Utf8.parse(saltKeyALIS);
      let _iv = CryptoJS.enc.Utf8.parse(saltKeyALIS);

      return CryptoJS.AES.encrypt(dataToEncrypt, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();
    } catch (e) {
      console.log(e);
    }
  }

  private toUtf8WithLatin1Fallback(wordArray: CryptoJS.lib.WordArray): string {
    try {
      return CryptoJS.enc.Utf8.stringify(wordArray);
    } catch (_) {
      return CryptoJS.enc.Latin1.stringify(wordArray);
    }
  }
}
